import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 20V12.24C20.9993 11.4446 20.6828 10.6821 20.12 10.12L13.29 3.29C13.1037 3.10526 12.8523 3.0011 12.59 3H11.41C11.1477 3.0011 10.8963 3.10526 10.71 3.29L3.88 10.12C3.31723 10.6821 3.0007 11.4446 3 12.24V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H8C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V14.5C9 14.3674 9.05268 14.2402 9.14645 14.1464C9.24021 14.0527 9.36739 14 9.5 14H14.5C14.6326 14 14.7598 14.0527 14.8536 14.1464C14.9473 14.2402 15 14.3674 15 14.5V20C15 20.2652 15.1054 20.5196 15.2929 20.7071C15.4804 20.8946 15.7348 21 16 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgHome = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgHome;
